module.exports = __webpack_public_path__ + "img/topindicator1.e496270d.png";